import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionComponent {
  idCliente
  data = {}

  constructor($q, ClienteInformacion, EmpresasCatalogoRegimenFiscal, Cliente) {
    this.$q = $q
    this.Cliente = Cliente
    this.ClienteInformacion = ClienteInformacion
    this.EmpresasCatalogoRegimenFiscalService = EmpresasCatalogoRegimenFiscal
  }

  $onInit () {
    this.promise = this.$q.all([
      this.ClienteInformacion.get(this.idCliente)
        .then(({ data }) => {
          this.data = data
          this.data.informacion.id_regimen_fiscal = +this.data.informacion.id_regimen_fiscal
        }),
      this.EmpresasCatalogoRegimenFiscalService.get()
        .then((response) => (this.regimenFiscal = response.data))
    ])
  }

  actualizarRepresentantes (data) {
    this.data.representantes = data
  }

  actualizar () {
    if (this.actualizando) return

    this.actualizando = true
    this.error = null

    this.Cliente.put(this.data.informacion, this.idCliente)
      .then(() => (this.informacion = false))
      .finally(() => (this.actualizando = false))
  }
}

module.component('clienteInformacion', {
  controller: ClienteInformacionComponent,
  template,
  bindings: {
    idCliente: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/component.js